export default __webpack_public_path__ + "static/media/fondo_normal.5ec54ca8.jpg";